export default __webpack_public_path__ + "static/media/consultation_fee_icon.3569111c.svg";